<template>
    <div class="wrapper">
        <div class="padding-sm bg-white flex-sub">
            <div class="classifys flex align-center">
                <router-link class="classify" to="/organization/members/exam">会员审核</router-link>
                <router-link class="classify active" to="/organization/members/fexam">分会会员审核</router-link>
            </div>
            <div class="flex align-center justify-between margin-bottom-sm list-search">
                <el-input
                    v-model="keyWord"
                    placeholder="请输入企业全称/法人姓名/联系电话"
                ></el-input>
                <el-button icon="el-icon-search" type="primary" @click="search">搜索</el-button>
            </div>
            <div class="ship-list">
                <el-table
                    v-loading="loading"
                    :data="lists" border
                    header-row-class-name="table-header"
                    style="width: 100%; border-radius: 10px">
                    <el-table-column
                        label="序号"
                        type="index"
                        width="50">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.$index + 1 }}
                            </div>
                        </template>
                    </el-table-column>

                    <el-table-column label="单位名称" prop="company" width="220px">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.company }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="所属协会" prop="company">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.fh_name }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="会员类别" prop="user_type">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.user_type === 1 ? '单位会员' : '个人会员' }}</div>
                        </template>
                    </el-table-column>
                    <!--            <el-table-column label="法人" prop="name">-->
                    <!--              <template slot-scope="scope">-->
                    <!--                <div class="table-name"> {{scope.row.morgname}}</div>-->
                    <!--              </template>-->
                    <!--            </el-table-column>-->
                    <el-table-column label="联系人" prop="name">
                        <template slot-scope="scope">
                            <div class="table-name"> {{ scope.row.name }}</div>
                        </template>
                    </el-table-column>
                    <el-table-column label="手机号" prop="phone" width="110px">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.phone }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="会员等级" prop="rank_name">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.rank_name }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="申请时间" prop="add_time" width="110px">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.add_time | setTime }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="金额" prop="amount">
                        <template slot-scope="scope">
                            <div class="table-name">
                                {{ scope.row.amount }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="支付信息"  width="180px">
                        <template slot-scope="scope">
                            <div class="flex justify-center  align-center">
                                <div class="table-name margin-right-sm">{{scope.row.register_type === 1 ? '微信付款' : scope.row.register_type === 2 ? '对公转账' : '未付款'}}</div>
                                <el-button class="table-operate line" @click="onPreview(scope.row.evidence)"  v-if="scope.row.register_type === 2">查看</el-button>
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="操作" width="200px">
                        <template slot-scope="scope">
                            <div class="flex justify-center  align-center">
                                <el-button class="table-operate" @click="toDetail(scope.row.id)">查看</el-button>
                                <el-button v-if="scope.row.is_check === 0" class="table-operate"
                                           @click="toDetail(scope.row.id)">审核
                                </el-button>
                                <el-button v-if="scope.row.is_check === 2" class="table-operate line"
                                           @click="toDetail(scope.row.id)">已拒绝
                                </el-button>
                            </div>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <el-pagination
                :current-page.sync="page"
                :page-size="limit"
                :total="total"
                background
                class="page-all margin-top"
                layout="prev, pager, next, jumper"
                @current-change="getCheckList">
            </el-pagination>
        </div>
        <el-image-viewer v-if="showViewer" :on-close="closeViewer" :url-list="srcList"></el-image-viewer>
    </div>
</template>

<script>
import {getCheckFHUserList} from "@/api/organiz";
import {zhDate} from "@/utils/utils";
import ElImageViewer from "element-ui/packages/image/src/image-viewer";

export default {
    name: "members",
    data() {
        return {
            keyWord: '',
            lists: [],
            page: 1,
            limit: 15,
            total: 0,
            loading: false,
        }
    },
    computed: {
        user() {
            return this.$store.state.user
        }
    },
    created() {
        this.$emit('setIndex', [3, 1], '会员审核')
        this.getCheckList()
    },
    components: {ElImageViewer},
    methods: {
        toDetail(id) {
            this.$router.push('/organization/members/examInfo/' + id)
        },
        search() {
            this.page = 1
            this.getCheckList()
        },
        // 获取等级
        async getCheckList() {
            let _list = await getCheckFHUserList(this.page, this.limit, this.keyWord)
            this.lists = _list.data
        },
        onPreview(url) {
            this.srcList = [url]
            this.showViewer = true
        },
        closeViewer() {
            this.showViewer = false
        },
    },
    filters: {
        setTime(val) {
            return zhDate(new Date(val * 1000))
        }
    },
    watch: {},
}
</script>

<style lang="scss" scoped>
.wrapper {
    .min-height {
        min-height: 930px;
    }

    .classifys {
        margin-bottom: 20px;
        .classify {
            width: 120px;
            height: 40px;
            line-height: 40px;
            text-align: center;
            border: 1px solid #ffb400;
            border-radius: 6px 0  0 6px;
            color: #ffb400;
            &.active {
                background: #ffb400;
                color: #FFFFFF;
                border-radius: 0 6px 6px 0;

            }
        }
    }

    .member-set {
        div {
            width: 171px;
            height: 50px;
            text-align: center;
            line-height: 50px;
            background-color: #f3f7fb;
            border-radius: 10px;
            border: solid 1px #dae0e6;
            font-size: 18px;
            cursor: pointer;

            &:hover {
                background-image: linear-gradient(37deg, #ffb400 0%, #fc7802 100%),
                linear-gradient(#0a2240, #0a2240);
                background-blend-mode: normal, normal;
                color: #fff;
            }
        }
    }

    .list-search {
        .el-button {
            border-top-left-radius: 0;
            border-bottom-left-radius: 0;
            background: #0a2240;
            border: 0;
            font-size: 16px;
        }
    }

    .table-name {
        font-size: 14px;
        color: #333333;
        text-align: center;

        &.gray {
            color: #999999;
        }
    }

    .table-operate {
        width: 60px;
        height: 30px;
        padding: 0;
        border-radius: 15px;
        background-color: #0a2240;
        border: solid 1px #0a2240;
        font-size: 14px;
        color: #ffffff;

        &.line {
            background-color: #ffffff;
            color: #0a2240;
        }

        &:disabled {
            background-color: #ffffff;
            border: solid 1px #dae0e6;
            color: #bcc6cf;
        }
    }
}
</style>
